import { z } from "zod";

import {
  SOFTWARE_TYPE_KEYS,
  type SoftwareTypeKey,
} from "@/features/servers/schemas/servers";

/**
 * Paridad con infra / backend: mismos valores que `SOFTWARE_TYPE_KEYS`
 * (lowercase: pacs, ris, his, …).
 */
export type SoftwareType = SoftwareTypeKey;

export const softwareTypes = SOFTWARE_TYPE_KEYS;

export type LicenseStatus = "active" | "revoked" | "expired";

export type LicenseRequestStatus = "pending" | "approved" | "rejected";

export const LICENSE_REQUEST_STATUSES: LicenseRequestStatus[] = [
  "pending",
  "approved",
  "rejected",
];

export interface IMachineLicense {
  licenseId: string;
  userId: string;
  machineId: string;
  clientName: string;
  softwareType: SoftwareType;
  signature: string;
  createdAt: string;
  expiresAt?: string;
  status: LicenseStatus;
}

/** Solicitud del installer (cola de aprobación). Colección `license_requests`. */
export interface ILicenseRequest {
  id: string;
  userId: string;
  machineId: string;
  clientName: string;
  softwareType: SoftwareType;
  status: LicenseRequestStatus;
  createdAt: string;
  updatedAt: string;
  licenseId?: string;
  decidedBy?: string;
  decidedAt?: string;
  reason?: string;
}

export interface GenerateLicenseRequest {
  machineId: string;
  clientName: string;
  softwareType: SoftwareType;
  userId: string;
}

export interface VerifyLicenseRequest {
  machineId: string;
  signature: string;
  softwareType: SoftwareType;
}

export interface VerifyLicenseResponse {
  valid: boolean;
}

export const GenerateLicenseSchema = z.object({
  machineId: z.string().min(1, "El ID de máquina es requerido"),
  clientName: z.string().min(1, "El nombre del cliente es requerido"),
  softwareType: z.enum(softwareTypes),
  userId: z.string().min(1, "El ID de usuario es requerido"),
});

export const VerifyLicenseSchema = z.object({
  machineId: z.string().min(1, "El ID de máquina es requerido"),
  signature: z.string().min(1, "La firma es requerida"),
  softwareType: z.enum(softwareTypes),
});

export type GenerateLicenseFormData = z.infer<typeof GenerateLicenseSchema>;
